document.addEventListener('DOMContentLoaded', function () {
    const swiperRelacionados = new Swiper('.slide-relacionados', {
        // Configurações básicas
        slidesPerView: 1,
        spaceBetween: 24,
        loop: false,
        speed: 500,

        // Navegação com setas personalizadas
        navigation: {
            nextEl: '.arrows-slide-relacionados .arrow-next',
            prevEl: '.arrows-slide-relacionados .arrow-prev',
        },

        // Breakpoints responsivos
        breakpoints: {
            // mobile
            320: {
                slidesPerView: 1,
                spaceBetween: 16
            },
            // tablet
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            // desktop
            992: {
                slidesPerView: 3,
                spaceBetween: 24
            }
        },

        // Acessibilidade
        a11y: {
            prevSlideMessage: 'Slide anterior',
            nextSlideMessage: 'Próximo slide',
        },

        // Callbacks opcionais
        on: {
            init: function () {
                // Atualiza estado das setas ao iniciar
                this.update();
            },
            slideChange: function () {
                // Ação opcional ao trocar de slide
            }
        }
    });
});